import { render, staticRenderFns } from "./term-adjust.vue?vue&type=template&id=6a23106a&"
import script from "./term-adjust.vue?vue&type=script&lang=js&"
export * from "./term-adjust.vue?vue&type=script&lang=js&"
import style0 from "./term-adjust.vue?vue&type=style&index=0&id=6a23106a&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports